import React from "react";
import { useParams } from "react-router-dom";
import DoctorProfile, { DoctorProfileData } from "../components/layout/DoctorProfile";
import Megapark  from "../assets/images/megapark.png"
import Recete3 from "../assets/images/recete3.jpg";
import { toUrl } from "../lib/config";

const DoctorProfilePage: React.FC = () => {
  const { slug } = useParams<{ slug: string }>();

  const DEFAULT_DATA: DoctorProfileData = {
    name: "",
    shortTitle: "",
    highlightSurname: "",
    heroBg: Recete3, // Tüm doktorlarda aynı arka plan
    portrait: Megapark,
    intro: "Doktor bilgileri yakında eklenecektir.",
    bioColumns: [[], []],
    sections: [],
    theme: { primary: "#2cadd2", dark: "#0f1b3a" },
  };

  const [data, setData] = React.useState<DoctorProfileData>(DEFAULT_DATA);
  const [loading, setLoading] = React.useState<boolean>(false);

  React.useEffect(() => {
    if (!slug) return;
    let cancelled = false;
    const normalizeImg = (raw?: string): string => {
      const s = (raw || "").trim();
      if (!s) return "";
      if (/^https?:\/\//i.test(s)) return s; // absolute URL
      if (s.startsWith("/api/")) return toUrl(s); // backend-relative
      // If API sends a bare UUID, build media URL
      if (/^[0-9a-fA-F-]{36}$/.test(s)) return toUrl(`/api/media/${s}`);
      // If API sends frontend build-time asset path, use local default portrait to ensure visibility
      if (s.startsWith("/assets/")) return Megapark as unknown as string;
      return s;
    };
    const run = async () => {
      try {
        setLoading(true);
        const res = await fetch(toUrl(`/api/doctor-profiles/${slug}`));
        if (!res.ok) throw new Error("fetch_failed");
        const obj = await res.json();
        const mapped: DoctorProfileData = {
          name: obj.name || DEFAULT_DATA.name,
          shortTitle: obj.shortTitle || DEFAULT_DATA.shortTitle,
          highlightSurname: obj.highlightSurname || DEFAULT_DATA.highlightSurname,
          heroBg: Recete3, // Sabit arka plan
          portrait: normalizeImg(obj.portrait) || DEFAULT_DATA.portrait,
          intro: obj.intro || DEFAULT_DATA.intro,
          bioColumns: Array.isArray(obj.bioColumns) ? obj.bioColumns : DEFAULT_DATA.bioColumns,
          sections: Array.isArray(obj.sections) ? obj.sections : DEFAULT_DATA.sections,
          theme: DEFAULT_DATA.theme,
        };
        if (!cancelled) setData(mapped);
      } catch (e) {
        // Fallback: DEFAULT_DATA
      } finally {
        if (!cancelled) setLoading(false);
      }
    };
    run();
    return () => { cancelled = true; };
  }, [slug]);

  return <DoctorProfile data={data} />;
};

export default DoctorProfilePage;
